// PERF-DASH-001 (Jul 2026) — in-flight request deduplication.
// Multiple components requesting the same URL+params at the same moment
// share ONE network request/promise. Entries clear on settle, so polling
// and heartbeats are unaffected (each new tick issues a fresh request).
import axios from 'axios';

const inflight = new Map();

export const dedupedGet = (url, config = undefined) => {
  const key = 'axios::' + url + '::' + JSON.stringify(config?.params || {});
  if (inflight.has(key)) return inflight.get(key);
  const p = axios.get(url, config).finally(() => { inflight.delete(key); });
  inflight.set(key, p);
  return p;
};

export const dedupedFetchJson = (url, options = undefined) => {
  const key = 'fetch::' + url;
  if (inflight.has(key)) return inflight.get(key);
  const p = fetch(url, options)
    .then((r) => (r.ok ? r.clone().json().then((data) => ({ ok: true, status: r.status, data })) : { ok: false, status: r.status, data: null }))
    .finally(() => { inflight.delete(key); });
  inflight.set(key, p);
  return p;
};
